import * as DOMPurify from "dompurify";

export const getSanitizedHtml = (rawHtml: string, allowedTags: string[]) => {
    return DOMPurify.sanitize(rawHtml, {
      ALLOWED_TAGS: allowedTags,
    });

};